export const PATH_APP = {
  root: '/',
  connect: (tenant) => `/${tenant}/connect`,
  type: (tenant) => `/${tenant}/type`,
  space: (tenant) => `/${tenant}/space`,
};
